export default {
  'topMenu': {
    'openSettings': 'Ouvrir les paramètres',
    'showAbout': 'Afficher les informations générales',
    'about': 'À propos d\'ORS',
    'pinSidebar': 'Épingler barre latérale',
    'settingsTooltip': 'Cliquez ici si vous souhaitez ajuster les paramètres de l\'application'
  }
}
